import React from 'react';
import { PracticeButton } from '../../buttons/practicebutton';
import bubbles from "../../mascot/bubble_right.svg";

/**
 * @author: Alisa Münsterberg
 * @date: 2022-10-14
 */

export default function FinishedListFeedback(props){

    /*
    * Renders and returns the finishedListFeedback component.
    * The content of the feedback is dependend on the values of the properties with which it is called.
    * Three different scenarios are possible:
    * 1. The list is sorted because the user followed all steps of the bubble sort algorithm and finished the task.
    *       The user can start a new task by clicking the PracticeButton.
    * 2. The user clicked the checkIfFinishedButton to before the execution of the algorithm was finished and the list is already sorted.
    *       The user can start a new task by clicking the PracticeButton.
    * 3. The user clicked the checkIfFinishedButton to before the execution of the algorithm was finished and the list is not sorted yet.
    *       The user can continue the current task.
    */

    return(
        <div className='feedbacksquare'>
            <img src={bubbles}  className="Feedback-Mascot" alt={"Bubbles, das Maskottchen des Bubblesort-Tutors, eine blaue und lilane Seifenblase."}/>    

            {(props.trulyFinished ?
                <div>
                    <p>Super, du bist dem Algorithmus bis zum Ende gefolgt und hast die Liste fertig sortiert!
                        Wenn du nochmal üben willst, klicke auf den Knopf:
                    </p>
                    <PracticeButton onClick= {() => props.reset()}/>
                </div>
            : (props.finished ?
                <div>
                <p> Du hast recht, die Liste ist schon fertig! Du siehst das, weil du die ganze Liste sehen und vergleichen kannst - der Computer kann das nicht.
                Er kann immer nur die beiden Zahlen miteinander vergleichen, die er gerade betrachtet.
                Deshalb muss er um die sortierte Liste zu bekommen alle Schritte des Bubblesort Algorithmus bis zum Ende durchführen.</p>
                <PracticeButton onClick= {() => props.reset()}/>
                </div>
                :
                <p> Leider ist die Liste noch nicht fertig sortiert - führe noch weitere Bubblesort-Schritte aus, 
                    um die Liste zu sortieren.
                </p>
                
            ))}   
        </div>
    )
}